import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 44.95 37.81"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.31 19.07c-.01.09-.01.17-.01.26 0 2.1 1.37 3.88 3.26 4.51h14.61v-4.77H5.31Z",
      style: {"fill":"#77a4dc"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M31.75 11.44h-8.42V2.38a2.38 2.38 0 1 0-4.76 0v9.06H0v.26c0 2.1 1.36 3.88 3.25 4.51h28.51c4.65 0 8.42 3.78 8.42 8.42s-3.78 8.42-8.42 8.42c-3.3 0-6.32-1.95-7.68-4.96l-.63-1.4h-13c-.01.08-.01.17-.01.25a4.74 4.74 0 0 0 3.27 4.51h6.76c2.37 3.91 6.65 6.36 11.29 6.36 7.27 0 13.19-5.92 13.19-13.19s-5.92-13.18-13.2-13.18Z",
      style: {"fill":"#0d3b70"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "SI-logo"}) } }